import { ALMOST_FULL_PERCENTAGE, UPGRADE_PERCENTAGE } from "./constants";

const ALMOST_FULL_COLOR = "#a90500";
const UPGRADE_COLOR = "#d9534f";
const DEFAULT_COLOR = "#15B4D4";

/**
 * Returns the color for the progress bar based on the percentage of space.
 *
 * @param percentageOfSpace - The percentage of space filled in the progress bar.
 * @returns The color code for the progress bar.
 */
const getProgressBarColor = (percentageOfSpace: number): string => {
  return percentageOfSpace > ALMOST_FULL_PERCENTAGE
    ? ALMOST_FULL_COLOR
    : percentageOfSpace > UPGRADE_PERCENTAGE
    ? UPGRADE_COLOR
    : DEFAULT_COLOR;
};

export default getProgressBarColor;
